"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireDefault(require("react"));
var humps = _interopRequireWildcard(require("humps"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _OverviewRow = _interopRequireDefault(require("../OverviewRow"));
var _EditableField = _interopRequireDefault(require("../EditableField"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "icon": "icon_1xSWgY"
}; 
require('./OverviewContactInfo.css');
var OverviewContactInfo = function OverviewContactInfo(_ref) {
  var asset = _ref.asset,
    canEdit = _ref.canEdit,
    updateContactInfo = _ref.updateContactInfo,
    valueValidator = _ref.valueValidator,
    renderIcon = _ref.renderIcon,
    renderField = _ref.renderField,
    placeholder = _ref.placeholder,
    actionMethod = _ref.actionMethod,
    fieldLabel = _ref.fieldLabel;
  var field = humps.camelize(fieldLabel);
  var fieldName = humps.camelize(field);
  var fieldId = "asset-".concat(humps.decamelize(field, {
    separator: '-'
  }));
  // read only use case
  if (asset[field] && !canEdit) {
    return /*#__PURE__*/_react.default.createElement(_OverviewRow.default, {
      title: fieldLabel,
      testId: fieldId
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: styles.icon,
      size: "s",
      "aria-hidden": true
    }, renderIcon()), renderField());
  }
  // admin use case
  if (canEdit) {
    return /*#__PURE__*/_react.default.createElement(_OverviewRow.default, {
      title: fieldLabel,
      testId: fieldId,
      isEditable: true
    }, /*#__PURE__*/_react.default.createElement(_EditableField.default, {
      value: asset[field],
      "data-test-id": "editable-".concat(fieldId),
      fieldName: fieldName,
      valueValidator: valueValidator,
      placeholder: placeholder,
      renderIcon: renderIcon,
      onSaveValue: ( /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value) {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return updateContactInfo(asset, actionMethod, field, value);
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }())
    }));
  }
  return null;
};
var _default = exports.default = OverviewContactInfo;
//# sourceMappingURL=OverviewContactInfo.js.map